module.exports = __webpack_public_path__ + "img/nav-logo.dd7f9c68.svg";